module.exports = __webpack_public_path__ + "img/contrSlope.1015ad07.svg";